import { gatewayClient } from '../utils/gatewayClient';

export interface FetchDependentsResponse {
  dependents: Array<{
    dependent_id: string;
    dependent_status: string;
    employee_full_name: string;
    first_name: string;
    last_name: string;
    middle_initial: string;
    relationship: string;
    reimbursement?: string;
    preferred_name?: never;
  }>;
}

export function fetchDependents({ statuses }: { statuses: string }) {
  return gatewayClient.get<FetchDependentsResponse>('/cdh/v2/dependents', {
    params: {
      statuses,
    },
  });
}

export function fetchDependentById(dependent_id: string) {
  return gatewayClient.get(`/api/v2/dependents/${dependent_id}`);
}

export function addNewDependent({
  first_name,
  last_name,
  phone,
  birth_date,
  address,
  shipping_address,
  relationship,
  country,
}: {
  first_name?: string;
  last_name?: string;
  phone?: string;
  birth_date?: string;
  address?: {
    line1?: string;
    line2?: string;
    country?: string;
    zip?: string;
    state?: string;
    city?: string;
  };
  shipping_address?: {
    line1?: string;
    line2?: string;
    country?: string;
    zip?: string;
    state?: string;
    city?: string;
  };
  relationship?: string;
  country?: string;
}) {
  return gatewayClient.post('/cdh/v2/dependents', {
    first_name,
    last_name,
    birth_date,
    address,
    shipping_address,
    phone,
    relationship,
    country,
  });
}

export function updateDependent(
  dependent_id: string,
  {
    first_name,
    last_name,
    address,
    phone,
    shipping_address,
    status,
    relationship,
    birth_date,
  }: {
    first_name?: string;
    last_name?: string;
    address?: {
      line1: string;
      line2?: string;
      city: string;
      state: string;
      country: string;
      zip: string;
    };
    phone?: string;
    shipping_address?: {
      line1: string;
      line2?: string;
      city: string;
      state: string;
      country: string;
      zip: string;
    };
    status?: string;
    relationship?: string;
    birth_date?: string;
  }
) {
  return gatewayClient.put(`/cdh/v2/dependents/${dependent_id}`, {
    first_name,
    last_name,
    phone,
    address,
    shipping_address,
    status,
    relationship,
    birth_date,
  });
}

export function deleteDependent(id: string) {
  return gatewayClient.delete(`/cdh/v2/dependents/${id}`);
}

export function deleteV2Dependent(id: string) {
  return gatewayClient.delete(`/api/v2/dependents/${id}`);
}

export function updateV2Dependent(
  id: string,
  {
    first_name,
    last_name,
    preferred_name,
    relationship,
    date_of_birth,
    email,
    phone,
    permission_to_speak_on_phone,
  }: {
    first_name: string;
    last_name: string;
    preferred_name: string;
    relationship: string;
    date_of_birth: string;
    email: string;
    phone: string;
    permission_to_speak_on_phone: boolean;
  }
) {
  return gatewayClient.put(`/api/v2/dependents/${id}`, {
    first_name,
    last_name,
    preferred_name,
    relationship,
    date_of_birth,
    email,
    phone,
    permission_to_speak_on_phone,
  });
}

export function fetchDependentDetails(dependent_id: string) {
  return gatewayClient.get(`/cdh/v2/dependents/${dependent_id}`);
}

export interface FetchNewDependentsResponse {
  dependents: Array<{
    id: string;
    employee_id: string;
    first_name: string;
    last_name: string;
    preferred_name?: string;
    phone?: string;
    email?: string;
    billing_address: {
      street?: string;
      locality?: string;
      state?: string;
      country?: string;
      zip?: string;
    };
    mailing_address?: {
      street?: string;
      locality?: string;
      state?: string;
      country?: string;
      zip?: string;
    };
    permission_to_speak_on_phone: boolean;
    date_of_birth: string;
    created: string;
  }>;
}

export function fetchNewDependents() {
  return gatewayClient.get<FetchNewDependentsResponse>(
    '/api/v2/dependents',
    {}
  );
}

export function addNewPretaxDependent({
  first_name,
  last_name,
  date_of_birth,
  preferred_name,
  phone,
  email,
  relationship,
  billing_address_street,
  billing_address_street_ext,
  billing_address_locality,
  billing_address_state,
  billing_address_country,
  billing_address_zip,
  mailing_address_street,
  mailing_address_street_ext,
  mailing_address_locality,
  mailing_address_state,
  mailing_address_country,
  mailing_address_zip,
  permission_to_speak_on_phone,
}: {
  first_name: string;
  last_name: string;
  date_of_birth: string;
  preferred_name?: string;
  phone?: string;
  email?: string;
  relationship?: string;
  billing_address_street?: string;
  billing_address_street_ext?: string;
  billing_address_locality?: string;
  billing_address_state?: string;
  billing_address_country?: string;
  billing_address_zip?: string;
  mailing_address_street?: string;
  mailing_address_street_ext?: string;
  mailing_address_locality?: string;
  mailing_address_state?: string;
  mailing_address_country?: string;
  mailing_address_zip?: string;
  permission_to_speak_on_phone: boolean;
}) {
  return gatewayClient.post('/api/v2/dependents', {
    first_name,
    last_name,
    date_of_birth,
    preferred_name,
    phone,
    email,
    relationship,
    billing_address_street,
    billing_address_street_ext,
    billing_address_locality,
    billing_address_state,
    billing_address_country,
    billing_address_zip,
    mailing_address_street,
    mailing_address_street_ext,
    mailing_address_locality,
    mailing_address_state,
    mailing_address_country,
    mailing_address_zip,
    permission_to_speak_on_phone,
  });
}
